import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from "scrollreveal";

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');

      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');
      });
    }

    //フッター/ヘッダーメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__menutitle').on('click', function () {
        event.preventDefault();
        $(this).toggleClass('is-open');
        $(this).next(".l-footer__menulist").toggleClass('is-open');
        $(this).next(".l-footer__menulist").slideToggle();
      })
      $('.c-slidebar-menu__menutitle').on('click', function () {
        event.preventDefault();
        $(this).toggleClass('is-open');
        $(this).next(".c-slidebar-menu__menulist").toggleClass('is-open');
        $(this).next(".c-slidebar-menu__menulist").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カルーセル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel').owlCarousel({
          items: 1,
          margin: 16,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_ノーマル
      owls.imagesLoaded(function () {
        $('.c-main-visual__carousel.is-normal').owlCarousel({
          items: 1,
          margin: 8,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>', '<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 32,
            },
            // breakpoint from 750  up
            750: {
              stagePadding: 64,
            },
            // breakpoint from 950 up
            950: {
              stagePadding: 156,
            },
            1400: {
              stagePadding: 312,
            }
          }
        });
      });
      //->カルーセル_レイヤー
      owls.imagesLoaded(function () {
        $('.c-main-visual-layer__carousel').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        });
      });
      //->カルーセル_レイヤー
      owls.imagesLoaded(function () {
        $('.c-works-main__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 56,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: true,
          autoHeight: true,
          center: false,
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              margin: 28,
            },
            // breakpoint from 750 up
            750: {
              margin: 56,
            }
          }
        });
      });

      owls.imagesLoaded(function () {
        if ($('.js-document-slider').children().length < 2) {
          $('.js-document-slider').toggleClass('owl-carousel');
          return false;
        }

        $('.js-document-slider').owlCarousel({
          margin: 0,
          items: 1,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 1000,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/grow-group-html/dist/assets/images/icon-slider-prev.png" width="49" height="49" />', '<img src="/wp-content/themes/grow-group-html/dist/assets/images/icon-slider-next.png" width="49" height="49" />']
        });
      });

    }

    // 上にスクロールした時にheaderを表示する処理
    function scrollHeader() {
      const ua = navigator.userAgent;
      if (ua.indexOf('Trident') !== -1) {
        return false;
      }
      var startPos = 0,
        winScrollTop = 0;
      $(window).on('scroll', function () {
        winScrollTop = $(this).scrollTop();
        if (winScrollTop >= startPos) {
          if (winScrollTop >= 100) {
            $('.l-header, .c-news-head').addClass('is-hide');
          }
        } else {
          $('.l-header, .c-news-head').removeClass('is-hide');
        }
        startPos = winScrollTop;
      });
    }

    function NewsHidden() {
      var $news = $('.c-news-head');
      var $header = $('.l-header');
      $(window).on('scroll', function () {
        //スクロール位置を取得
        if ($(this).scrollTop() > 400) {
          $news.css('display', 'none');
          $header.css('top', '0');
        }
      });
    }

    function MainVisual() {
      $('.c-main-visual-animation__overflow.is-last').on('DOMSubtreeModified propertychange', function () {
        $(this).addClass('is-active');
        setTimeout(function () {
          $('.c-main-visual-animation__overflow.is-last').removeClass('is-active');
        }, 1700);
      });
    }


    // "recruit"ディレクトリの中にあるpage-headerにis-recruitクラスを追加する
    // margin-topを消すため
    function dirAddClass() {
      var loc = location.pathname.split("/");

      if (loc.indexOf('recruit') >= 1) {
        $('.l-page-header').addClass('is-recruit');
      }
    }

    function scrollReaval() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600, mobile: false});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      //top
      sr.reveal(".c-main-visual,.l-page-header__outer,.c-vision-main,.c-main-visual-recruit", {
        delay: 200,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '0',
      }, 100);


      sr.reveal(".c-main-visual__title", {
        delay: 1000,
        scale: 1,
        duration: 600,
        origin: 'left',
        distance: '16px',
      }, 100);

      sr.reveal(".c-main-visual__text", {
        delay: 1200,
        scale: 1,
        duration: 600,
        origin: 'left',
        distance: '-8px',
      }, 100);

      sr.reveal(".c-hero-block__photo", {
        delay: 1200,
        scale: 1,
        duration: 800,
        origin: 'top',
        distance: '-8px',
      }, 100);

      sr.reveal(".c-block-recruit__photo", {
        delay: 500,
        scale: 1,
        duration: 800,
        origin: 'top',
        distance: '-8px',
      }, 100);
      sr.reveal(".c-block-recruit__en", {
        delay: 800,
        scale: 1,
        duration: 800,
        origin: 'right',
        distance: '8px',
      }, 100);

      sr.reveal(".c-block-gallery__image", {
        delay: 1000,
        scale: 1,
        duration: 800,
        origin: 'right',
        distance: '16px',
      }, 100);

      var blocks01 = $(".c-hero-block__content__inner,.c-card-white__flex,.c-card-post__flex,.c-block-recruit__content,.c-vertical-block,.c-box-card__wrap,.c-flow-box__wrap,.c-hero-block-down__block,.c-design-solution__wrap,.c-vision-texts__wrap,.c-brand,.c-recruit-culture__content,.c-block-message");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 800, delay: 400}, 200);
        sr.reveal(item.children[0], {delay: 600, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[1], {delay: 800, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[2], {delay: 1000, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[3], {delay: 1100, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[4], {delay: 1300, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[5], {delay: 1400, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[6], {delay: 1500, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[7], {delay: 1600, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[8], {delay: 1700, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[9], {delay: 1800, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[10], {delay: 1900, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[11], {delay: 2000, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);
        sr.reveal(item.children[12], {delay: 2100, scale: 1, duration: 800, origin: 'bottom', distance: '16px'}, 300);

      });


    }

    function CountUpNumber() {
      if ($('.js-countup-num').length === 0) {
        return false;
      }
      var countup_timing = [];
      var checking = false;
      $('.js-countup-num').each(function (index, element) {
        var target = $(this);
        var startNum = target.attr('data-start');
        console.log(startNum);
        target.text(startNum);
      });
      var animation_time = 500;//1000ms = 1s
      function onscroll() {
        if (checking) {
          return true;
        }
        checking = true;
        var disp_pos = $(this).scrollTop() + ($(window).innerHeight() / 1.1);
        $('.js-countup-num').each(function (index, element) {
          if (countup_timing[index] != undefined) {
            return true;
          }

          var obj_offset_top = $(this).offset().top;
          if (obj_offset_top < disp_pos) {
            var target = $(this);
            var startNum = target.attr('data-start');
            var endNum = target.attr('data-end');
            var step = parseFloat(target.attr('data-step'));
            var dispNum;
            if (!step) {
              step = 1;
            }
            var speed = parseInt(target.attr('data-speed'));
            if (!speed) {
              speed = parseInt(animation_time / (parseInt(endNum) - parseInt(startNum)) * step);
            }
            target.text(startNum);
            if (startNum != endNum) {
              var countNum = parseFloat(startNum);
              countup_timing[index] = setInterval(function () {
                if (startNum < endNum) {
                  countNum += step;
                } else {
                  countNum -= step;
                }
                dispNum = countNum;
                if(step < 1){
                  dispNum = dispNum.toFixed(1);
                }
                target.text(dispNum);
                if (countNum >= endNum) {
                  clearInterval(countup_timing[index]);
                  target.attr('data-start', endNum);
                  target.text(endNum);
                }
              }, speed);
            }
          }
        });
        checking = false;
      }
      $(window).scroll(onscroll);
      $(document).ready(onscroll);

    }

    function officeGallery() {

      var slides = $('.c-gallery-slider__thumbnail .c-gallery-slider__thumbnail-image').length;


      if ( slides < 2) {
        $(".c-gallery-slider__thumbnail").addClass("is-simple-none");
      }

      var $mainSlider = $('.c-gallery-slider__main');

      // 上段
      $mainSlider.slick({
        infinite: true,
        arrow: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><img src="/wp-content/themes/grow-group-html/dist/assets/images/icon-slider-prev.svg" /></div>',
        nextArrow: '<div class="slick-next"><img src="/wp-content/themes/grow-group-html/dist/assets/images/icon-slider-next.svg" /></div>',
        asNavFor: '.c-gallery-slider__thumbnail',
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1500,
        // centerPadding: '23.28%',
        centerMode: true,
        variableWidth: true,
        dots: false,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 5000,
            slidesToShow: 1
          }
        }]
      });

      var $thumbnailSlider = $('.c-gallery-slider__thumbnail');

      // 下段
      $thumbnailSlider.slick({
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 2500,
        speed: 1500,
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        variableWidth: true,
        asNavFor: '.c-gallery-slider__main',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 950,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 6
          }
        },
          {
            breakpoint: 750,
            settings: {
              variableWidth: false,
              autoplaySpeed: 2500,
              slidesToShow: 4
            }
          }]
      });
    }

    $(function () {
      menuSlide();
      owlCarousel();
      scrollHeader();
      //dirAddClass();
      NewsHidden();
      scrollReaval();
      MainVisual();
      CountUpNumber();
      officeGallery();
    });
  }
}

window.GApp = new App();
